export var HANDLE_ICON_DEFAULT_CFG = {
    fill: '#fff',
    stroke: '#bfbfbf',
    lineWidth: 1,
    size: 10,
    radius: 2,
    strokeOpacity: 1,
};
export var HANDLE_LABEL_DEFAULT_CFG = {
    fontSize: 12,
    fill: '#000',
    fillOpacity: 0.45,
    textAlign: 'center',
    textBaseline: 'middle',
};
export var HANDLE_DEFAULT_CFG = {
    orient: 'horizontal',
    type: 'start',
    showLabel: true,
};
//# sourceMappingURL=constant.js.map